import React, { Component } from "react";
import TableRow from "./TableRow";
import TableRowEdicion from "./TableRowEdicion";

class TableBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tarjetaCreditoId: 0,
            filaClickeadaEnModoEdicion: false
        }

        this.mostrarFilaEnModoEdicion = this.mostrarFilaEnModoEdicion.bind(this);
    }

    /**
     * 
     * @param {any} tarjetaCreditoId
     * @param {any} filaEnModoEdicion
     */
    mostrarFilaEnModoEdicion(tarjetaCreditoId, filaEnModoEdicion) {
        this.setState({
            tarjetaCreditoId: tarjetaCreditoId,
            filaClickeadaEnModoEdicion: filaEnModoEdicion,
        });
    }

    render() {
        let rows = [];
        const { tarjetas, modalidadDistribucionLimiteId, limiteCompraCodigo } = this.props;

        tarjetas.forEach((tar) => {
            let modoEdicion = (tar.TarjetaCreditoId == this.state.tarjetaCreditoId);

            if (modoEdicion == true && this.state.filaClickeadaEnModoEdicion == true) {
                modoEdicion = false;
            }

            rows.push(
                <TableRow
                    tarjeta={tar}
                    modalidadDistribucionLimiteId={modalidadDistribucionLimiteId}
                    limiteCompraCodigo={limiteCompraCodigo}
                    filaEnModoEdicion={modoEdicion}
                    mostrarFilaEnModoEdicion={this.mostrarFilaEnModoEdicion} />
            );

            rows.push(
                <TableRowEdicion
                    tarjeta={tar}
                    filaEnModoEdicion={modoEdicion}
                    modalidadDistribucionLimiteId={modalidadDistribucionLimiteId}
                    limiteCompraCodigo={limiteCompraCodigo} />
            );
        });

        return <tbody>
            {rows}
        </tbody>
    }
}

export default TableBody;